function Excel({ className = 'h-6 w-6' }) {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99902 1H4.66552C4.48876 1 4.31923 1.07022 4.19424 1.19521C4.06924 1.32021 3.99902 1.48973 3.99902 1.6665V4.5L9.99902 8L12.999 9.266L15.999 8V4.5L9.99902 1Z'
        fill='#21A366'
      />
      <path
        d='M3.99902 4.5H9.99902V8H3.99902V4.5Z'
        fill='#107C41'
      />
      <path
        d='M15.3325 1H9.99902V4.5H15.999V1.6665C15.999 1.48973 15.9288 1.32021 15.8038 1.19521C15.6788 1.07022 15.5093 1 15.3325 1Z'
        fill='#33C481'
      />
      <path
        d='M9.99902 8H3.99902V14.3335C3.99902 14.5103 4.06924 14.6798 4.19424 14.8048C4.31923 14.9298 4.48876 15 4.66552 15H15.3325C15.5093 15 15.6788 14.9298 15.8038 14.8048C15.9288 14.6798 15.999 14.5103 15.999 14.3335V11.5L9.99902 8Z'
        fill='#185C37'
      />
      <path
        d='M9.99902 8H15.999V11.5H9.99902V8Z'
        fill='#107C41'
      />
      <path
        opacity='0.1'
        d='M8.33252 3.5H3.99902V13H8.33252C8.50913 12.9995 8.67835 12.9291 8.80323 12.8042C8.92811 12.6793 8.9985 12.5101 8.99902 12.3335V4.1665C8.9985 3.9899 8.92811 3.82068 8.80323 3.6958C8.67835 3.57092 8.50913 3.50053 8.33252 3.5Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M7.83252 4H3.99902V13.5H7.83252C8.00913 13.4995 8.17835 13.4291 8.30323 13.3042C8.42811 13.1793 8.4985 13.0101 8.49902 12.8335V4.6665C8.4985 4.4899 8.42811 4.32067 8.30323 4.1958C8.17835 4.07092 8.00913 4.00053 7.83252 4Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M7.83252 4H3.99902V12.5H7.83252C8.00913 12.4995 8.17835 12.4291 8.30323 12.3042C8.42811 12.1793 8.4985 12.0101 8.49902 11.8335V4.6665C8.4985 4.4899 8.42811 4.32067 8.30323 4.1958C8.17835 4.07092 8.00913 4.00053 7.83252 4Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M7.33252 4H3.99902V12.5H7.33252C7.50913 12.4995 7.67835 12.4291 7.80323 12.3042C7.92811 12.1793 7.9985 12.0101 7.99902 11.8335V4.6665C7.9985 4.4899 7.92811 4.32067 7.80323 4.1958C7.67835 4.07092 7.50913 4.00053 7.33252 4Z'
        fill='black'
      />
      <path
        d='M0.665523 4H7.33252C7.50929 4 7.67882 4.07022 7.80381 4.19521C7.9288 4.32021 7.99902 4.48973 7.99902 4.6665V11.3335C7.99902 11.5103 7.9288 11.6798 7.80381 11.8048C7.67882 11.9298 7.50929 12 7.33252 12H0.665523C0.488757 12 0.31923 11.9298 0.194237 11.8048C0.0692438 11.6798 -0.000976562 11.5103 -0.000976562 11.3335L-0.000976562 4.6665C-0.000976562 4.48973 0.0692438 4.32021 0.194237 4.19521C0.31923 4.07022 0.488757 4 0.665523 4Z'
        fill='#107C41'
      />
      <path
        d='M1.76465 10.5L3.38265 7.993L1.90065 5.5H3.09315L3.90215 7.0935C3.97648 7.2445 4.02765 7.35717 4.05565 7.4315H4.06615C4.11948 7.31083 4.17531 7.1935 4.23365 7.0795L5.09815 5.5H6.19265L4.67265 7.979L6.23115 10.5H5.06615L4.13165 8.75C4.08762 8.67546 4.05031 8.59715 4.02015 8.516H4.00615C3.97888 8.59536 3.94264 8.67135 3.89815 8.7425L2.93665 10.5H1.76465Z'
        fill='white'
      />
    </svg>
  )
}
export default Excel
